"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _client = require("@apollo/client");
var _router = require("next/router");
var _react = _interopRequireWildcard(require("react"));
var _reactErrorBoundary = require("react-error-boundary");
var _reactIntl = require("react-intl");
var _Spinner = _interopRequireDefault(require("../components/designsystem/Spinner"));
var _ErrorFallback = _interopRequireDefault(require("../components/ErrorFallback"));
var _TenantContext = require("../context/TenantContext");
var _auth = require("../utils/auth");
var _getApolloErrorType = _interopRequireDefault(require("../utils/getApolloErrorType"));
var _sentry = _interopRequireDefault(require("../utils/sentry"));
var _useAuth = require("../hooks/useAuth");
const _excluded = ["Spinner", "withLoadingProp"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const {
  captureException
} = (0, _sentry.default)();
const Fallback = props => {
  const {
    0: errorHandled,
    1: setErrorHandled
  } = (0, _react.useState)(true);
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  (0, _react.useEffect)(() => {
    if (props.error) {
      props.onError(props.error, setErrorHandled);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (errorHandled) {
    return __jsx(_Spinner.default, {
      message: __jsx(_reactIntl.FormattedMessage, {
        id: "aXLE6j",
        defaultMessage: [{
          "type": 0,
          "value": "Mijn "
        }, {
          "type": 1,
          "value": "island"
        }],
        values: {
          island: brandConfig.name
        }
      })
    });
  }
  return __jsx(_ErrorFallback.default, props);
};
const withAuth = (Component, options = {}) => {
  function Enhanced(props) {
    const {
        Spinner: SpinnerFromOptions,
        withLoadingProp
      } = options,
      useAuthOptions = (0, _objectWithoutProperties2.default)(options, _excluded);
    const SpinnerComponent = SpinnerFromOptions ?? _Spinner.default;
    const {
      failUrl,
      showSpinner,
      isAuthorized
    } = (0, _useAuth.useAuth)(useAuthOptions);
    const router = (0, _router.useRouter)();
    const client = (0, _client.useApolloClient)();
    const {
      brandConfig
    } = (0, _TenantContext.useTenantContext)();
    if (!withLoadingProp && showSpinner) {
      return __jsx(SpinnerComponent, {
        message: __jsx(_reactIntl.FormattedMessage, {
          id: "aXLE6j",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn "
          }, {
            "type": 1,
            "value": "island"
          }],
          values: {
            island: brandConfig.name
          }
        })
      });
    }
    return __jsx(_reactErrorBoundary.ErrorBoundary, {
      fallbackRender: errProps => __jsx(Fallback, (0, _extends2.default)({
        onError: async (error, setErrorHandled) => {
          captureException(error);
          const errorType = (0, _getApolloErrorType.default)(error) ?? '500';
          if (['401'].includes(errorType)) {
            const success = await (0, _auth.refresh)();
            if (!success) {
              (0, _auth.logout)();
              await client.resetStore();
              if (failUrl) {
                router.replace(failUrl);
                return;
              }
            }
            errProps.resetErrorBoundary();
          } else {
            setErrorHandled(false);
          }
        }
      }, errProps))
    }, __jsx(Component, (0, _extends2.default)({}, props, {
      loading: showSpinner,
      isAuthorized: isAuthorized
    })));
  }
  Enhanced.displayName = `WithAuthComponent`;
  return Enhanced;
};
var _default = exports.default = withAuth;